export default "__VITE_ASSET__Bm6VmTE3__"